<template>
  <div class="pg-index stop-swiping">
    <div class="main-swiper swiper-container">
      <div class="swiper-wrapper" ref="wrapper">
        <!-- p1 -->
        <div class="swiper-slide p1">
          <!-- <div class="logo"></div> -->
          <div class="btn-wrap">
            <div class="times">剩余抽奖次数:<span class="emphsis">{{chance}}</span></div>
            <div class="draw" @click="lotto"></div>
          </div>
          <div class="btn-wrap btn-wrap-2">
            <div class="times times-call">召集<span class="emphsis">1位</span>兄弟,增加<span class="emphsis">1次</span>抽奖机会</div>
            <div class="call" @click="callFriend"></div>
            <!-- <div class="call-times">还可以召集{{userInfo.weixin_state ? userInfo.invitablenum : 4}}名兄弟</div> -->
          </div>
          <div class="lucky">
            <autoScroll :list.sync="luckyList" :config="config">
              <template v-slot="vData">
                <!-- 数据渲染列表 -->
                <li v-for="(item, index) in vData.vDota" :key="index" class="iztVnode-item" :style="{ height: vData.config.itemHeight + 'px',lineHeight: vData.config.itemHeight + 'px' }">
                  <span class="lucky-name">{{item.nickname}}</span>&nbsp;&nbsp;已抽到&nbsp;&nbsp;<span class="lucky-prize">{{item.item_name}}</span>
                </li>
              <!-- 数据渲染列表 -->
              </template>
            </autoScroll>
          </div>
          <div class="frame">
            <div class="frame-bg">
              <div class="frame-title"></div>
              <div class="prize-wrapper swiper-container prize-swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide frame-slide"  v-for="(item, index) in prize" :key="index">
                    <Prize v-for="(prize, pIndex) in item" :key="pIndex" :prize="prize.icon" :name="prize.name"></Prize>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination prize-pagination">
                <div
                  class="swiper-pagination-bullet"
                  :class="[
                    prizeSwiper.activeIndex === index ? 'swiper-pagination-bullet-active' : ''
                  ]"
                  v-for="(item, index) in bullets"
                  :key="index"
                  @click="prizeSwiper.slideTo(index, 600, 0)"
                >
                  <div :class="`swiper-pagination-bullet-${index + 1}`"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="slide-prev" @click="slidePrev"></div>
          <div class="slide-prev next" @click="slideNext"></div>
        </div>
        <!-- p2 -->
        <div class="swiper-slide p2" ref="p2">
          <div
            class="get"
            :class="{disabled: !prizeList.list || prizeList.list.some(x => x.state) && userInfo.charname}"
            @click="getPrize"
          ></div>
          <div class="bind" :class="{disabled: userInfo.isbind}" @click="bindRole"></div>
          <div v-if="userInfo.isbind" class="role">
            <span class="role-title">已绑定角色：</span>
            <span class="role-name">{{userInfo.charname}}</span>
          </div>
          <Frame class="big-frame" :style="{height: (prizeHeight + 32)/100 + 'rem'}">
            <div v-if="!prizeList.list || !prizeList.list.length" class="none">暂无奖励</div>
            <div v-else class="desc">点击图标，<span style="color: #c21000">选择10种</span>想要领取的奖励</div>
            <div class="prize-wrapper">
              <Prize
                v-for="(prize, index) in prizeList.list"
                :key="index"
                :prize="prize.icon"
                :name="prize.title"
                :drawed="prize.state"
                :id="prize.id"
                :choosed="myPrize.length ? myPrize.some(x => x.id === prize.id) : false"
                :can-draw="!prize.state && prizeList.list && !prizeList.list.some(x => x.state) && myPrize.length < 10"
                @toggle="togglePrize"
              >
              </Prize>
            </div>
          </Frame>
        </div>
        <!-- p3 -->
        <div class="swiper-slide p3">
          <div class="rule-title"></div>
          <Frame class="big-frame">
            <div class="rule-wrapper">
              <div class="rule">
                <div class="rule-seq"></div>
                <div class="rule-content">活动时间：2022年12月14日~2022年12月17日</div>
              </div>
              <div class="rule">
                <div class="rule-seq"></div>
                <div class="rule-content">
                  <span class="emphasis">十连抽奖：</span><br>奖励均为《原始征途》游戏内道具，从页面公示的奖池中抽取，品质由高到低为紫、绿、黄、蓝，抽出概率递减。
                </div>
              </div>
              <div class="rule">
                <div class="rule-seq"></div>
                <div class="rule-content">
                  <span class="emphasis">召集助力：</span><br>
                  <span>
                    1、默认有一次十连抽机会，还可召集兄弟助力增加机会；将页面分享给好友即可发起召集，好友助力成功后，便可增加一次10连抽的机会，最多可以额外增加4次。
                  </span><br>
                  <span>2、每位玩家仅有一次为好友助力的机会，受邀完成一次助力之后，将无法再为其他玩家进行助力。</span>
                </div>
              </div>
              <div class="rule">
                <div class="rule-seq"></div>
                <div class="rule-content">
                  <span class="emphasis">绑定角色：</span><br>
                  领取奖励前，玩家需要通过登录巨人通行证绑定《原始征途》终极测试区中的已创建角色；本次活动仅面向终极测试区服，并且首次绑定后将无法换绑。
                </div>
              </div>
              <div class="rule">
                <div class="rule-seq"></div>
                <div class="rule-content">
                  <span class="emphasis">奖励领取：</span><br>
                  <span>
                    1、可以在”我的奖励“界面中查看已经抽到的奖励，并且从已经抽到的奖励任意选择10个奖励领取到游戏中。
                  </span><br>
                  <span>2、活动期间，玩家只能领取一次奖励，领取的奖励数量必须为10个。</span>
                </div>
              </div>
              <div class="rule">
                <div class="rule-seq"></div>
                <div class="rule-content">
                  <span class="emphasis">奖励发放：</span><br>
                  领奖后，奖励将以自动发放至玩家绑定的《原始征途》角色账号之中，需自行前往查收。
                </div>
              </div>
              <div class="rule">
                <div class="rule-seq"></div>
                <div class="rule-content">
                  <span class="emphasis">注意事项：</span><br>
                  <span>
                    1、如使用外挂等不正当方式参加本活动的，官方将有权取消用户参与及获奖资格。
                  </span><br>
                  <span>2、如有任何问题，请联系《原始征途》手游官方客服，客服电话021-61205656。</span>
                </div>
              </div>
            </div>
          </Frame>
        </div>
      </div>
    </div>
    <div class="header">
      <div class="game_icon"></div>
      <div class="game_button fr">
        <a href="/index.shtml"></a>
        <a v-if="!ingame" href="javascript:;" class="downloadbtn ios" target="_self" @click="iosHandler"></a>
        <a href="javascript:;" class="downloadbtn android" target="_self" @click="downloadHandler"></a>
      </div>
    </div>
    <div class="slogan"></div>
    <!-- <div class="login">
      <span v-if="!userInfo || !userInfo.weixin_state">亲爱的用户, 请 <a class="link" @click="checkLoginStatus">登录</a></span>
      <span v-else>欢迎您 <span class="name">{{userInfo.shareinfo.nickname}}</span></span>
    </div> -->
    <div class="swiper-pagination main-pagination">
      <div
        class="swiper-pagination-bullet"
        :class="[
          `swiper-pagination-bullet-${index + 1}`,
          activeIndex === index ? 'active' : ''
        ]"
        v-for="(item, index) in bullets"
        :key="index"
        @click="slideTo(index)"
      >
      </div>
    </div>
  </div>
</template>
<script>
import store from "~/store/index";
import * as types from "~/store/mutation-type";
import { mapState } from "vuex";
import { isWeiXin, getParameterByName, isAndroid } from "~/tools/utils";
import autoScroll from "~/components/autoScroll.vue";
import Alert from "~/components/Alert";
import confirm from "~/components/Confirm";
import Frame from "~/components/Frame/frame.vue";
import Prize from "~/components/Prize/index.vue";
import api from "~/api/api";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
// import IScroll from 'iscroll/build/iscroll-probe'

export default {
  components: {Prize, Frame, autoScroll},
  data() {
    return {
      isAndroid: isAndroid(),
      isEditing: false,
      loggedIn: false,
      account: "",
      bullets: [
        "十连抽奖",
        "我的奖励",
        "活动规则"
      ],
      prize: [
        [
          {icon: 30, name: '大哥大嫂图鉴(7天)'},
          {icon: 29, name: '坐骑图鉴礼包(7天)'},
          {icon: 28, name: '专属称号(15天)'},
          {icon: 27, name: '绿色押镖令+培训令牌'},
          {icon: 26, name: '升星宝石*10'},
          {icon: 25, name: '材料助力礼包'},
          {icon: 24, name: '魂魄助力礼包'},
          {icon: 23, name: '成长助力礼包'},
          {icon: 4, name: '天香蜜露'},
          {icon: 22, name: '三等硬皮*5'},
        ],
        [
          {icon: 21, name: '三等秘银*5'},
          {icon: 20, name: '二等硬皮*5'},
          {icon: 19, name: '二等秘银*5'},
          {icon: 16, name: '竹蜻蜓 *10'},
          {icon: 12, name: '1两银子 *50'},
          {icon: 10, name: '隐身符 *10'},
          {icon: 6, name: '回城卷 *10'},
          {icon: 3, name: '大还丹 *99'},
          {icon: 18, name: '一等硬皮*5'},
          {icon: 17, name: '一等秘银*5'},
        ],
        [
          {icon: 15, name: '竹蜻蜓 *5'},
          {icon: 14, name: '蓝色培训令牌*2'},
          {icon: 13, name: '蓝色押镖令*2'},
          {icon: 12, name: '1两银子 *50'},
          {icon: 11, name: '1两银子 *25'},
          {icon: 9, name: '隐身符 *5'},
          {icon: 8, name: '白色培训令牌*5'},
          {icon: 7, name: '白色押镖令*5'},
          {icon: 5, name: '回城卷 *5'},
          {icon: 4, name: '天香蜜露'},
          {icon: 2, name: '大还丹 *50'},
          {icon: 1, name: '大还丹 *25'}
        ],
      ],
      myPrize: [],
      mgplayer: {},
      swiper: {},
      prizeSwiper: {},
      downUrl:'',
      wxtitle: "邀你助力《原始征途》终极测试福利五十连抽",
      wxdesc: "老史送豪礼，终极五十连抽！时装礼包、专属称号、升星宝石……助你终极测试战力飞升！",
      wximages: "https://" + window.location.host + "/act/blc/share.jpg",
      matchList: [],
      prviousIndex: 0,
      activeIndex: 0,
      ingame: getParameterByName("ingame"),
      luckyList: [],
      config: {
        itemHeight: 36 * window.innerWidth / 750, // 滚动行高度 默认50
        sCro: 1, // 默认为0:禁止自动上下滚动
        startsCro: 1, // 控制什么时候开始 1
        overFlow: 1 // 0不允许手指或者鼠标滑动  默认1
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      chance: state => state.chance,
      prizeList: state => state.prizeList,
      modal: state => state.modal
    }),
    prizeHeight() {
      let height =  (this.prizeList.list ? this.prizeList.list.length : 0) * 173/5 + 128
      return height
    },
  },
  mounted() {
    if(!isWeiXin()) {
      Alert("请在微信中打开")
    }
    // TODO 测试弹窗 需去掉
    // store.commit(types.SHOW_MODAL, {type: 'copy', copy: 'https://lh.web.ztgame.com/act/blc/#/share?fid=2'})
    // let url = `https://yszt.ztgame.com/download/${this.isAndroid ? 'android' : 'ios'}.html`
    // store.commit(types.SHOW_MODAL, {type: 'times', copy: 'https://lh.web.ztgame.com/act/blc/#/share?fid=2'})
    const _this = this;

    requirejs(["weixin/main", "downloadway/main", 'login/index', "jquery"], (weixin, Download, gLogin, $) => {
      // window.setShare = setShare
      var appid = 'wx0fcf7f47419c8171';

      if(!_this.ingame) {
        window.Download = Download
        new Download({
          iosBtn: $(".ios"),
          androidBtn: $(".android"),
          display: "block",
          tip: "iOS版本敬请期待",
          callback: function (info) {},
        });
      }

      window.glogin = new gLogin({
          type:'popup',
          menu_idx: 'smcd|account',
          //设置 去注册按钮
          fastreg:{
              //注意：不支持回调函数
          },
          onLogin:function(result,fromeCookie,fromReg){
              if(fromeCookie){
                  console.log('从cookie自动登录');
                  store.commit(types.UPDATE_USER, Object.assign({}, _this.userInfo, {loggedIn: true}));
              }
              //if(fromReg){
                  //console.log('新注册用户');
              //}
              if(!!result&&!!result.account){
                  //登录成功
                  //alert('登录成功');
                  store.commit(types.UPDATE_USER, Object.assign({}, _this.userInfo, {loggedIn: true}));
                  if(!_this.userInfo.charname && _this.userInfo.toBind) {
                    store.commit(types.SHOW_MODAL, {type: 'bind'});
                  }
              }
              else{
                  //登录失败
                  Alert(result.msg);
              }
          }
      });

      api.getUserInfo().then(res => {
        if(res.status === 1) {
          store.commit(types.UPDATE_USER, res);
          store.commit(types.UPDATE_CHANCE, res.chance);
          if(res.weixin_state) {
            console.log(`重设分享链接`);
            window.wx = new weixin(appid,() => {
              //朋友圈
              wx.onMenuShareTimeline({
                  title: `${res.shareinfo.nickname}邀你助力《原始征途》终极测试福利五十连抽`, // 分享标题
                  link: window.location.origin + `/act/blc/#/share?fid=${res.shareinfo.userid}`, // 分享链接
                  imgUrl: this.wximages
              });
              //朋友
              wx.onMenuShareAppMessage({
                  title: `${res.shareinfo.nickname}邀你助力《原始征途》终极测试福利五十连抽`, // 分享标题
                  desc: this.wxdesc, // 分享描述
                  link: window.location.origin + `/act/blc/#/share?fid=${res.shareinfo.userid}`, // 分享链接
                  imgUrl: this.wximages, // 分享图标
                  type: 'link' // 分享类型,music、video或link，不填默认为link
              });
              if(this.ingame) {
                window.wx.miniProgram.postMessage({data: { fid: res.shareinfo.userid }});
              }
            });
            store.commit(types.SHOW_LOADING, false);
            return api.getPrizeList();
          } else {
            window.wx = new weixin(appid,() => {
              //朋友圈
              wx.onMenuShareTimeline({
                  title: `${res.shareinfo.nickname}邀你助力《原始征途》终极测试福利五十连抽`, // 分享标题
                  link: window.location.href, // 分享链接
                  imgUrl: this.wximages
              });
              //朋友
              wx.onMenuShareAppMessage({
                  title: `${res.shareinfo.nickname}邀你助力《原始征途》终极测试福利五十连抽`, // 分享标题
                  desc: this.wxdesc, // 分享描述
                  link: window.location.href, // 分享链接
                  imgUrl: this.wximages, // 分享图标
                  type: 'link' // 分享类型,music、video或link，不填默认为link
              });
            });
          }
        } else {
          window.wx = new weixin(appid,() => {
            //朋友圈
            wx.onMenuShareTimeline({
                title: `${res.shareinfo.nickname}邀你助力《原始征途》终极测试福利五十连抽`, // 分享标题
                link: window.location.href, // 分享链接
                imgUrl: this.wximages
            });
            //朋友
            wx.onMenuShareAppMessage({
                title: `${res.shareinfo.nickname}邀你助力《原始征途》终极测试福利五十连抽`, // 分享标题
                desc: this.wxdesc, // 分享描述
                link: window.location.href, // 分享链接
                imgUrl: this.wximages, // 分享图标
                type: 'link' // 分享类型,music、video或link，不填默认为link
            });
          });
        }
        store.commit(types.SHOW_LOADING, false);
      }).then(res => {
        if(res && res.status === 1) {
          let prizeList = Object.assign({}, this.prizeList, {
            list: res.list.reduce((a, b) => a.concat(b), [])
          })
          store.commit(types.UPDATE_PRIZE, prizeList);
        }
      }).catch(err => {
        store.commit(types.SHOW_LOADING, false);
      });
    })

    try {
      let baseOption = {
        allowTouchMove: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        preventInteractionOnTransition: true,
        autoHeight: true
      }

      this.prizeSwiper = new Swiper(".prize-swiper", Object.assign({}, baseOption, {
        speed: 600,
        direction: 'horizontal'
      }));
    } catch (error) {
      console.log(error);
    }
    this.$refs.wrapper.style.height = 1759*window.innerWidth/750 > window.innerHeight ? '8.72rem' : 'calc(100vh - 8.87rem)'

    api.getLuckyList().then(res => {
      if(res && res.status === 1) {
        this.luckyList = res.list
      }
    });

    // 轮询抽奖次数
    setTimeout(() => {
      this.getScheduleStatus()
    }, 4e3);
  },
  watch:{
    'prizeList.list': {
      handler: function (newValue) {
        if(newValue && newValue.length && !newValue.some(x => x.state)) {
          this.myPrize = newValue.slice(0, 10)
        } else {
          this.myPrize = []
        }
      },
      deep: true
    },
    'userInfo.toDraw': {
      handler: function (newValue) {
        if(newValue) {
          this.getPrize()
        }
      }
    }
  },
  methods: {
    getScheduleStatus() {
      api.getUserInfo().then(res => {
        if(res.status === 1) {
          // store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {
          //   chance: res.chance
          // }));
          store.commit(types.UPDATE_CHANCE, res.chance);
        }
      }).finally(() => {
        setTimeout(() => {
          this.getScheduleStatus()
        }, 4e3);
      });
    },
    iosHandler() {
      _paq.push(['trackEvent', 'BLC-Download', 'Home', 'ios', 'ios'])
    },
    downloadHandler() {
      let platform = this.isAndroid ? 'android' : 'ios'
      _paq.push(['trackEvent', 'BLC-Download', 'Home', platform, platform])
      if(this.ingame) {
        let url = `https://yszt.ztgame.com/download/${platform}.html`
        store.commit(types.SHOW_MODAL, {type: 'copy', copy: url})
      }
    },
    togglePrize({checked, id, icon, name}) {
      if(checked) {
        this.myPrize.push({id, icon, name})
      } else {
        this.myPrize = this.myPrize.filter(x => x.id !== id)
      }
    },
    slidePrev() {
      this.prizeSwiper && this.prizeSwiper.slidePrev()
    },
    slideNext() {
      this.prizeSwiper && this.prizeSwiper.slideNext()
    },
    lotto() {
      if(!this.checkLoginStatus()) {
        return
      }
      if(!this.chance) {
        // Alert("召集兄弟增加次数，<br>每召集一个兄弟增加一次")
        store.commit(types.SHOW_MODAL, {type: 'times'})
        return
      }
      if(this.loading) {
        return
      }
      store.commit(types.SHOW_LOADING, true)
      this.loading = true;
      let lottoRes;
      api.lotto().then(res => {
        if(res.status === 1) {
          store.commit(types.UPDATE_CHANCE, this.chance - 1);
          lottoRes = res;
          return api.getPrizeList();
        }
      }).then(res => {
        if(res && res.status === 1) {
          let prizeList = Object.assign({}, this.prizeList, {
            list: res.list.reduce((a, b) => a.concat(b), [])
          })
          store.commit(types.UPDATE_PRIZE, prizeList);
        }
        this.$nextTick(() => {
          store.commit(types.SHOW_MODAL, {type: 'win', win: [...lottoRes.info.item_detail]});
        })
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      }).catch(() => {
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      })
    },
    callFriend() {
      if(!this.checkLoginStatus()) {
        return
      }
      if(this.ingame) {
        store.commit(types.SHOW_MODAL, {type: 'copy', copy: window.location.origin + `/act/blc/#/share?fid=${this.userInfo.shareinfo.userid}`})
      } else {
        store.commit(types.SHOW_MODAL, {type: 'share'});
      }
    },
    slideTo(index) {
      if(index === 2) {
        store.commit(types.SHOW_MODAL, {type: 'rule'})
        return
      }
      if(index === this.activeIndex) {
        return
      }
      this.previousIndex = this.activeIndex
      this.activeIndex = index
      switch (this.activeIndex) {
        case 0:
          this.$refs.wrapper.style.height = 1759*window.innerWidth/750 > window.innerHeight ? '8.72rem' : 'calc(100vh - 8.87rem)' // 1170
          break;
        case 1:
          let height = (this.prizeHeight + 32 + 225 + 114)*window.innerWidth/750
          this.$refs.p2.style.height = this.$refs.wrapper.style.height = this.prizeHeight + 32 > 264 ? ((this.prizeHeight + 32 + 225 + 114)/100 + 'rem') : '6.35rem'
          break;
        // case 2:
        //   this.$refs.wrapper.style.height = 1825*window.innerWidth/750 > window.innerHeight ? '18.25rem' : '100vh' // 1170
        //   break;
        default:
          break;
      }
      this.$refs.wrapper.style.transitionDuration = '1s'
      // let value = this.activeIndex >= this.previousIndex ? -this.activeIndex : this.activeIndex
      this.$refs.wrapper.style.transform = `translateX(${-this.activeIndex * 100}%)`
      window.scrollTo(0, 0);
    },
    checkLoginStatus() {
      if(!this.userInfo.weixin_state) {
        let url = '/act/blc/api/api.php?c=index&a=wxauth'
        if(import.meta.VITE_APP_ENV !== 'production') {
          url = 'https://yszt.web.ztgame.com/act/blc/api/api.php?c=index&a=wxauth'
        }
        if(this.ingame) {
          url += '&ingame=ingame'
        }
        location.replace(url)
        return false;
      }
      return true
    },
    bindRole() {
      if(!this.userInfo.charname) {
        if(this.userInfo.loggedIn) {
          store.commit(types.SHOW_MODAL, {type: 'bind'});
          return;
        }
        glogin.login();
        store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {toBind: true}));
      } else {
        Alert("已绑定");
      }
    },
    async getPrize() {
      store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {toDraw: false}));
      if(!this.userInfo.charname) {
        if(this.userInfo.loggedIn) {
          store.commit(types.SHOW_MODAL, {type: 'bind'});
          return;
        }
        glogin.login();
        store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {toBind: true}));
        return;
      }
      if(!this.prizeList.list) {
        Alert("暂无可领取的奖励");
        return;
      }
      if(this.prizeList.list.some(x => x.state)) {
        Alert("您已领奖");
        return;
      }
      if(this.myPrize.length < 10) {
        Alert("请选择10个奖励进行领取");
        return;
      }
      await confirm(this.myPrize, this.prizeList);
      if(this.loading) {
        return
      }
      this.loading = true;
      api.draw(this.myPrize.map(x => x.id)).then(res => {
        if(res.status === 1) {
          Alert('领取成功，<br>奖励将在15分钟内发送至游戏中，<br>请及时查收');
          this.prizeList.list.map(x => {
            if(this.myPrize.some(prize => x.id === prize.id)) {
              x.state = 1
            }
            return x;
          });
          store.commit(types.UPDATE_USER, this.userInfo)
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    goHome() {
      location.href = "/index.shtml"
    }
  },
};
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
@font-face{
    font-family: fzshjt;
    src: url('./fzshjt.TTF')
}
.pg-index
  position: relative
  width: 7.5rem
  background-color #490302
  padding-top 8.87rem
  background-image: url('./images/bj.png')
  background-size: 7.5rem 17.59rem
  background-position: center top
  background-repeat no-repeat
  overflow hidden
  .emphsis
    color #fcff00
    font-weight bold
  .header
    position: fixed
    top 0
    left 0
    width: 100%;
    height: 1.04rem;
    display: block;
    z-index 2
    background-color rgba(0,0,0,0.75)
    .game_icon
      margin: 0.09rem 0 0 0.27rem;
      width: 2.16rem;
      height: 0.86rem;
      background: url(https://yszt.ztgame.com/assets/logo.png) no-repeat;
      background-size: 100% auto;
    .game_button {
      position: absolute;
      right: 0.3rem;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      width 2.91rem
      &>a {
        display: block;
        width: 1.36rem;
        height: 0.5rem;
        background: url(./images/home.png) no-repeat;
        background-size: 100% 100%;
      }

      .downloadbtn {
        width: 1.35rem;
        background-image: url(./images/download.png);
      }
    }
    .home {
      position: absolute
      top: 0.27rem
      right: 0.23rem
      width: 1.34rem
      height: 0.5rem
      // background-image: url('./images/home.png')
      background-size: 100% 100%
    }

    .bt-download {
      position: absolute
      top: 0.27rem
      right: 1.69rem
      width: 1.34rem
      height: 0.5rem
      background-size: 100% 100%
    }
  .login
    position absolute
    top 3.23rem
    width 100%
    text-align center
    color #ffffe1
    font-size 0.22rem
    line-height 1
    z-index 1
    .name
      color #fb794c
    .link
      color #ffffe1
      text-decoration underline
  .human
    position: absolute
    top: 1.45rem
    left: 0
    width: 2.03rem
    height: 2.26rem
    background-image: url('./images/human.png')
    background-size: contain
    // transform-origin: top left
    animation: slideInLeft 0.5s linear
  .ball
    position: absolute
    top: 1.82rem
    left: 1.44rem
    width: 0.73rem
    height: 0.73rem
    background-size: contain
    animation: rotate 1.5s linear infinite
  .prize
    position: absolute
    top: 4.15rem
    width: 0.5rem
    height: 1.22rem
    background-image: url('./images/prize.png')
    background-size: 100% 100%
    z-index 1
  .share
    position: absolute
    top: 5.61rem
    width: 0.5rem
    height: 1.22rem
    background-image: url('./images/share.png')
    background-size: 100% 100%
    z-index 1
  .slogan {
    position absolute
    top 6.02rem
    left 0.54rem
    width 6.27rem
    height 2.65rem
    background:url(./images/slogan.png) no-repeat;
    background-size contain
    animation slideInDown 1s ease
  }
  .main-swiper {
    width: 100%
    padding-bottom: constant(safe-area-inset-bottom)
    padding-bottom: env(safe-area-inset-bottom)

    .swiper-slide {
      min-height: calc(100vh - 8.87rem);
      height: auto;
      .tit {
        position: absolute
        top: 1.15rem
        left: 50%
        width: 6.09rem
        height: 1.49rem
        background-size: 100% 100%
        transform: translateX(-50%)
      }
      .sub-title {
        position: absolute
        top 2.53rem
        color: #ce4e27
        text-align: center
        width 100%
        font-style: normal
        font-size: 0.26rem
        &-3,&-4,&-5,&-6 {
          letter-spacing 0.15rem
        }
      }
      .slide-button {
        outline: none;
        position absolute
        z-index 2
        top 50%
        margin-top -0.13rem
        width 0.37rem
        height 0.7rem
        background:url(./images/m/leftArrow.png) no-repeat;
        background-size contain
        cursor pointer
        &-prev {
          left 0.27rem
        }
        &-next {
          right 0.27rem
          margin-left 5.67rem
          transform rotate(180deg)
        }
      }

      .big-frame {
        position absolute
        top 2.25rem
        left 0.3rem
        min-height: calc(100vh - 4.56rem);
        min-height: 2.64rem;
      }

      &.p1 {
        height: 16.74rem
        height: calc(16.74rem + constant(safe-area-inset-bottom))
        height: calc(16.74rem + env(safe-area-inset-bottom))
        .lucky {
          position absolute
          top 1.59rem
          width 100%
          text-align center
          font-size 0.22rem
          line-height 0.36
          height 0.36rem
          color: #ff7860
          &-prize {
            font-weight bold
            color: #a300f7
          }
          &-name {
            font-weight bold
            color: #ffe8a2
          }
          /deep/.iztVnode-item {
            font-size 0.24rem
          }
        }
        .logo {
          position absolute
          top 0.2rem
          left 0.13rem
          width 1.23rem
          height 1.14rem
          background:url(./images/logo.png) no-repeat;
          background-size contain
        }
        .btn-wrap {
          width: 3.15rem
          height: 2.02rem
          position: absolute
          top 0
          left 0.23rem
          animation slideInLeft 1s ease forwards
          animation-delay 0.5s
          transform translateX(-100%)
          display flex
          flex-direction column
          align-items center
          &-2 {
            left 3.87rem
            transform translateX(100%)
            animation-name slideInRight
          }
          .times {
            text-align center
            font-size 0.20rem
            color: #fff
            line-height: 0.36rem
            width 2.15rem
            height 0.36rem
            border-radius 0.165rem
            background-color #000
            &-call {
              width: 3.15rem
              margin-left 0
            }
          }
          .call-times {
            margin-left: 0.405rem
            width 2.81rem
            height 0.36rem
            margin-top -0.03rem
            text-align center
            font-size 0.22rem
            color: #fffefe
            line-height: 0.36rem
            border-radius 0.165rem
            background-color #d23325
          }
          .draw {
            width 2.8rem
            height 1rem
            background:url(./images/draw.png) no-repeat;
            background-size contain
            margin-top 0.14rem
          }
          .call {
            margin-top 0.14rem
            width 2.8rem
            height 1rem
            background:url(./images/call.png) no-repeat;
            background-size contain
            padding-top 1.36rem
            text-align center
            color #a36c3e
            line-height 1
            font-weight bold
            font-size 0.18rem
          }
        }
        .slide-prev {
          position absolute
          top 4.74rem
          left 0.07rem
          width 0.26rem
          height 0.5rem
          background:url(./images/prev.png) no-repeat;
          background-size contain
          &.next {
            transform rotate(180deg)
            left auto
            right 0.1rem
          }
        }
        .frame {
          height 5.1rem
          position absolute
          z-index 2
          left 0.3rem
          top 2.25rem
          width 6.91rem
          &-slide {
            background none
            min-height 3.46rem
            // height 3.46rem
            padding-left: 0.1rem
            // width: 6.05rem
            display flex
            flex-wrap wrap
            &:last-child {
              // padding-left: 0.01rem
              // width: 5.95rem
            }
          }
          .frame-bg {
            width 100%
            height 5.24rem
            background:url(./images/frame.png) no-repeat;
            background-size contain
          }
          .frame-title {
            position absolute
            left 2.37rem
            top 0.29rem
            width 2.15rem
            height 0.95rem
            background:url(./images/prize-title.png) no-repeat;
            background-size contain
          }
          .prize-wrapper {
            position absolute
            top: 1.07rem
            left: 0.48rem
            width: 6.05rem
            height: 3.46rem;
          }
        }
      }

      &.p2 {
        .prize-wrapper {
          padding: 0.24rem 0 0.24rem 0.58rem;
          display flex
          flex-wrap wrap
        }
        .none {
          font-size 0.3rem
          text-align center
          color #666
          margin-top 0.4rem
        }
        .desc {
          padding-top: 0.58rem;
          font-size 0.24rem
          font-weight bold
          color #000
          line-height 1
          text-align center
        }
        .get {
          position absolute
          left 50%
          margin-left -1.4rem
          top 0.5rem
          width 2.8rem
          height 1rem
          background-image url('./images/get.png')
          background-size: 100% 100%
          background-repeat: no-repeat
          background-position: bottom center
          &.disabled {
            filter: grayscale(100%);
            filter: gray;
          }
        }
        .bind {
          position absolute
          left 5.74rem
          top 0.69rem
          width 1.31rem
          height 0.46rem
          background-image url('./images/bind.png')
          background-size: 100% 100%
          background-repeat: no-repeat
          background-position: bottom center
          &.disabled {
            filter: grayscale(100%);
            filter: gray;
          }
        }
        .role {
          line-height 1
          position absolute
          font-size 0.2rem
          font-weight bold
          top 1.66rem
          text-align center
          color #c8a276
          width 100%
          &-name {
            width: 1.84rem;
            color: #ffe8a2
            // overflow: hidden;
            // white-space: nowrap;
            // text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .logo {
    z-index: 2
    position: fixed
    top: 0.15rem
    left: 0.26rem
    background-size: 100% auto
    background-repeat:no-repeat
  }

  .prize-pagination {
    position: absolute
    left: 3.15rem
    top: 4.81rem
    display: flex
    justify-content: space-between
    width: 0.61rem
    height: 0.1rem

    .swiper-pagination-bullet {
      display: inline-block
      width: 0.1rem
      opacity: 1
      height: 0.1rem
      background-color #894d1d

      &.swiper-pagination-bullet-active {
        background-color: #cc4717;
      }
    }
  }

  .main-pagination {
    position: fixed
    bottom: 0
    left: 0
    z-index: 2
    display: flex
    justify-content: space-between
    width: 7.5rem
    height: 1.05rem
    height: calc(1.05rem + constant(safe-area-inset-bottom))
    height: calc(1.05rem + env(safe-area-inset-bottom))
    background-color: #1d0101
    padding-bottom: constant(safe-area-inset-bottom)
    padding-bottom: env(safe-area-inset-bottom)
    padding: 0.14rem 0.33rem;

    .swiper-pagination-bullet {
      display: inline-block
      width: 2.45rem
      opacity: 1
      border-radius 0
      height: 0.77rem
      background: url('./images/menu1.png');
      background-size 2.45rem 0.77rem
      &.active {
        background-image: url('./images/menu1-active.png');
      }
      &-2 {
        background-image: url('./images/menu2.png');
        &.active {
          background-image: url('./images/menu2-active.png');
        }
      }
      &-3 {
        width 1.65rem
        background-image: url('./images/menu3.png');
        background-size 1.65rem 0.77rem
      }
    }
  }

  .hide
    display: none

@keyframes horse {
  to {
    background-position-y: -29.75rem;
  }
}
@keyframes slideInLeft {
  0% {
    opacity: 0
    transform: translateX(-100%)
  }

  100% {
    opacity: 1
    transform: translateX(0)
  }
}
@keyframes slideInRight {
  0% {
    opacity: 0
    transform: translateX(100%)
  }

  100% {
    opacity: 1
    transform: translateX(0)
  }
}
@keyframes slideInDown {
  0% {
    opacity: 0
    transform: translateY(-100%)
  }

  100% {
    opacity: 1
    transform: translateY(0)
  }
}
@keyframes scaleIn {
  0% {
    opacity: 0
    transform: scale(0)
  }

  100% {
    opacity: 1
    transform: scale(1)
  }
}
@keyframes scale {
  0% {
    transform: scale(1)
  }

  100% {
    transform: scale(1.1)
  }
}

@keyframes rotate {
  to {
    transform: rotate(360deg)
  }
}

@keyframes scaleTr {
  to {
    transform scale(1.2)
  }
}

@keyframes zuoqi {
  to {
    background-position-y: -19.90rem;
  }
}

@media screen and (max-aspect-ratio: 9/16) {
  .main-swiper {
    .swiper-slide {
      .section {
        .frame {
          &.scroll {
            height calc(100vh - 5.85rem) !important
          }
        }
      }

      &.p2 {
        .champion-wrapper {
          height calc(100vh - 8.03rem) !important
        }
      }
    }
  }
}

@media screen and (min-aspect-ratio: 9/16) {
  .main-swiper {
    .swiper-slide {
      .section {
        transform-origin top center
      }
    }
  }
}


@keyframes ani-card-cover-translate {
    0% {
        transform: rotateY(-180deg) scale(1.02) skewY(0deg);
    }

    10% {
        opacity: .5;
    }

    20% {
        opacity: .8;
        transform: rotateY(-180deg) scale(1.1) skewY(0deg);
    }

    30% {
        transform: rotateY(-90deg) scale(1.19) skewY(-12deg);
    }

    70% {
        opacity: 1;
        transform: rotateY(0deg) scale(1.1,1.4) skewY(0deg);
    }

    100% {
        opacity: 1;
        transform: rotateY(0deg) scale(1) skewY(0deg);
    }
}

@keyframes ani-card-back-translate {
    0% {
        transform: rotateY(0deg) scale(1.02) skewY(0deg);
    }

    10% {
        opacity: .5;
    }

    20% {
        opacity: .8;
        transform: rotateY(0deg) scale(1.1) skewY(0deg);
    }

    30% {
        transform: rotateY(-90deg) scale(1.19) skewY(-12deg);
    }

    70% {
        opacity: 1;
        transform: rotateY(-180deg) scale(1.1,1.4) skewY(0deg);
    }

    100% {
        opacity: 1;
        transform: rotateY(-180deg) scale(1) skewY(0deg);
    }
}

@keyframes ani-yellow-card-cover-translate {
    0% {
        transform: rotateY(-180deg) scale(1.02) skewY(0deg) translate(0rpx,0rpx);
    }

    10% {
        opacity: .5;
    }

    20% {
        opacity: .8;
        transform: rotateY(-180deg) scale(1.1) skewY(0deg) translate(0rpx,0rpx);
    }

    30% {
        transform: rotateY(-90deg) scale(1.29) skewY(-12deg);
    }

    70% {
        opacity: 1;
        transform: rotateY(0deg) scale(1.2,1.6) skewY(0deg) translate(10rpx,10rpx);
    }

    100% {
        opacity: 1;
        transform: rotateY(0deg) scale(1) skewY(0deg) translate(0rpx,0rpx);
    }
}

@keyframes ani-yellow-card-back-translate {
    0% {
        transform: rotateY(0deg) scale(1.02) skewY(0deg) translate(0rpx,0rpx);
    }

    10% {
        opacity: .5;
    }

    20% {
        opacity: .8;
        transform: rotateY(0deg) scale(1.1) skewY(0deg) translate(0rpx,0rpx);
    }

    30% {
        transform: rotateY(-90deg) scale(1.29) skewY(-12deg);
    }

    70% {
        opacity: 1;
        transform: rotateY(-180deg) scale(1.2,1.6) skewY(0deg) translate(10rpx,10rpx);
    }

    100% {
        opacity: 1;
        transform: rotateY(-180deg) scale(1) skewY(0deg) translate(0rpx,0rpx);
    }
}
</style>
